import { FrameRectangle, ListSummaryLoader, ProductCardListLoader } from '@commerce-cart-webcomponents/ui';
import styles from './MyListItemsLoader.module.scss';

export const MyListItemsBannerLoader = () => (
  <div className={styles['my-list-items-loader-banner']}>
    <FrameRectangle className={styles['my-list-items-loader-banner-mobile']} />
    <FrameRectangle className={styles['my-list-items-loader-banner-box']} />
  </div>
);

export const MyListItemsLoader = ({ isWishlist = false }: { isWishlist?: boolean }) => (
  <div className={styles['my-list-items-loaders-container']}>
    <div className={styles['my-list-items-loader-wrapper']}>
      {[...Array(3).keys()].map((key) => (
        <ProductCardListLoader key={key} className={styles['my-list-items-loader-card']} isWishList={isWishlist} />
      ))}
    </div>

    <ListSummaryLoader />
  </div>
);
